import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const peopleProfilesEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() => {
		if (!__SERVER__) {
			return import(/* webpackChunkName: "async-people-profiles-entrypoint" */ './src');
		}

		return Promise.resolve({ default: () => null });
	}),
	getPreloadProps: () => ({}),
});
